// Advanced audio processing configuration for noise suppression
export const ADVANCED_AUDIO_CONFIG = {
  // Enhanced browser constraints - more stable settings
  constraints: {
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: false, // Disable AGC to prevent sudden volume changes
    // Advanced noise suppression settings
    googEchoCancellation: true,
    googAutoGainControl: false, // Disable to prevent recording interruptions
    googNoiseSuppression: true,
    googHighpassFilter: true,
    googTypingNoiseDetection: true,
    googAudioMirroring: false,
    // No sampleRate constraint: WebRTC's Opus codec is natively 48kHz, so
    // forcing 44100 capture triggers a resample that smears consonants. Let
    // the browser use its native rate so no resample happens before encoding.
    channelCount: 1,
  },

  // Voice activity detection thresholds (stricter for better accuracy)
  voiceThresholds: {
    speechMin: -40, // Slightly higher threshold for clearer speech
    noiseFloor: -60, // Higher threshold to filter background noise
    voiceRatio: 0.12, // Less sensitive to prevent false positives
    peakThreshold: 5, // Higher peak threshold for clearer signals
    averageThreshold: 2, // Higher average threshold
  },

  // Audio processing parameters
  processing: {
    fftSize: 2048, // Reduced for better performance and stability
    smoothingTimeConstant: 0.8, // Less aggressive smoothing
    sampleRate: 44100, // Standard sample rate for better compatibility

    // Frequency ranges for voice isolation
    voiceFreqRange: {
      min: 80, // Slightly lower to capture more voice frequencies
      max: 8000, // Keep high-frequency noise filtering
      speechMin: 200, // Lower to capture more speech
      speechMax: 4000, // Slightly higher for better speech capture
    },

    // Noise gating parameters (less restrictive to prevent stops)
    noiseGate: {
      threshold: -45, // Lower threshold to be less restrictive
      ratio: 8, // Less aggressive ratio
      attack: 0.003, // Slightly slower attack
      release: 0.15, // Faster release to prevent cutting off speech
      holdTime: 0.05, // Shorter hold time
    },
  },

  // Recording limits
  limits: {
    maxSizeMB: 100, // 100MB limit
    maxDurationMinutes: 30, // 30 minutes max
    minDurationSeconds: 2, // Minimum 1 second
  },
};
